// Copyright (C) 2022 Cochise Ruhulessin
//
// All rights reserved. No warranty, explicit or implicit, provided. In
// no event shall the author(s) be liable for any claim or damages.
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
import { IonItem, IonItemGroup, IonLabel, IonList, IonNote } from '@ionic/react'
import * as iso3166 from 'i18n-iso-countries'
import { useLocales } from 'react-localized'


interface CountrySelectorProps {
  children?: React.ReactNode
  onSelected(code: string): void
  value?: string
}


const clientLocale: string | undefined | null = (navigator.languages && navigator.languages.length)
  ? navigator.languages[0]
  : navigator.language
const defaultCountry: string | undefined = (!!clientLocale)
  ? ((new Intl.Locale(clientLocale)).region || "NL")
  : "NL"


const CountrySelector: React.FC<CountrySelectorProps> = (props) => {
  const {gettext, locale} = useLocales()
  const countries: {[key: string]: any} = iso3166.getNames(locale, {select: "alias"})
  const defaultCountryName: string = iso3166.getName(props.value || defaultCountry, locale)
  const onSelected: (code: string) => void = (code) => {
    props.onSelected(code)
  }

  return (
    <>
      <IonList>
        <IonItem
          detail
          onClick={() => onSelected(props.value || defaultCountry)}
          style={{cursor: "pointer", marginBottom: "11px"}}
        >
          <IonLabel>{defaultCountryName}</IonLabel>
          <IonNote slot="helper">{gettext("Tik om verder te gaan.")}</IonNote>
        </IonItem>
        <IonItem lines="none" style={{marginBottom: "11px"}}>
          {props.children}
        </IonItem>
      </IonList>
      <IonList>
        <IonItem lines="none" style={{"--padding-start": "20px"}}>
          <IonLabel><h2 style={{fontSize: "18px"}}>{gettext("Meer Landen and Gebieden")}</h2></IonLabel>
        </IonItem>
        <IonItemGroup>
          {Object.keys(countries).map((code) => {
            let country = countries[code]
            return (
              <IonItem
                detail
                key={code}
                onClick={() => onSelected(code)}
                style={{cursor: "pointer"}}
              >
                <IonLabel>{country}</IonLabel>
              </IonItem>
          )})}
        </IonItemGroup>
      </IonList>
    </>
  )
}


export { CountrySelector }